import { lazy } from 'react';

//sets the pages display settings

const DriverProfileConfig = {
  settings: {
    layout: {
        style : 'layout1',
        config: {
          
            navbar : {
                display : false,
                
            },
            toolbar: {
                display : false,
            },
            footer : {
                display : false,
                
            },
            mode   : 'fullwidth'
        }
    },
    
},
  routes: [
    {
      path: '/profile',
      component: lazy(() => import('./ViewDriver')),
    },
  ],
};

export default DriverProfileConfig;
